// 24 Oct 2026 (Nas, page weight): moved out of snippets/adore-fx-site.liquid so the browser can cache it. Code unchanged.
(function(){
  if(window.__adoreUpsellBound2) return; window.__adoreUpsellBound2=true; window.__adoreUpsellBound=true;
  document.addEventListener('click',function(e){
    var btn=e.target&&e.target.closest?e.target.closest('[data-adore-upsell-items],[data-adore-upsell-add]'):null; if(!btn) return;
    e.preventDefault(); e.stopPropagation();
    var items;
    try { items = btn.hasAttribute('data-adore-upsell-items') ? JSON.parse(btn.getAttribute('data-adore-upsell-items')) : [{id:Number(btn.getAttribute('data-adore-upsell-add')),quantity:1}]; } catch(err) { btn.textContent='Try again'; return; }
    btn.disabled=true; btn.textContent='Adding';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){
        if(!r.ok) throw new Error('add failed');
        var C=window.theme&&window.theme.Cart, inBag=btn.closest('.popup-cart, .js-popup-cart-ajax');
        if(!inBag||!C||typeof C.updateData!=='function'){ window.location.href='/cart'; return; }
        /* 25 Oct 2026 (Nas, phone recording: the bag "disappears and reappears for a second" after an add): theme.Popups.callByName
           has no already-open check, it removes the bag's "show visible" classes and puts them back a tick later, so the open
           animation replays. The bag is only opened here if it is not open already. */
        return C.updateData().then(function(){ return C.updateCart(); }).then(function(){ try{ var bag=document.querySelector('[data-js-popup-name="cart"]'); if(!(bag&&bag.classList.contains('visible')&&document.body.classList.contains('popup-opened'))) C.showPopup(); }catch(x){} })
          .catch(function(){ window.location.href='/cart'; });
      })
      .catch(function(){ btn.disabled=false; btn.textContent='Try again'; });
  },true);
})();

(function(){
  function install(){
    var $=window.jQuery, C=window.theme&&window.theme.Cart;
    if(!$||!C||typeof C.addItem!=='function'||window.__adoreAtc) return !!window.__adoreAtc;
    window.__adoreAtc=true;
    /* 24 Oct 2026 (Nas, phone video: Add to cart "super laggy", 5 of the same rug in the bag). Three changes:
       a) the bag opens the moment Add to cart is tapped, with an "Adding ..." line, and fills in when Shopify answers;
       b) after a rug is added its button reads "In your bag" and opens the bag instead of adding the same size again
          (a new size, or the rug removed from the bag, makes it an Add to cart button again);
       c) the bag contents are requested at the same time as the cart total, not after it (saves 0.3 to 2 s). */
    var IN='data-adore-inbag';
    /* 24 Oct 2026 (panel audit, build 9): the sticky bar's button keeps its label in a plain span with no .btn__text inside,
       so it never showed "Adding" or "In your bag" and never got the double-add guard. The plain span is now accepted too. */
    function txtEl(b){ var t=b.querySelector(':scope > span:not([data-button-content]) .btn__text'); if(t) return t; var s=b.querySelector(':scope > span:not([data-button-content])'); return (s && !s.children.length) ? s : null; }
    function idInput(){ return document.querySelector('form[action*="/cart/add"] [name="id"]')||document.querySelector('[name="id"][form^="product-form"]')||document.querySelector('[data-js-product] [name="id"]'); }
    function mainId(){ var i=idInput(); return i?String(i.value):''; }
    function btnId(b){ var f=b.closest('form'), i=f&&(f.querySelector('[name="id"]')||(f.id&&document.querySelector('[name="id"][form="'+f.id+'"]'))); return i?String(i.value):mainId(); }
    function inCart(id){ var d=C.currentData; return !!(d&&d.items&&d.items.some(function(it){ return String(it.variant_id)===String(id); })); }
    function setInBag(b,id){ var t=txtEl(b); if(!t) return; if(!t.hasAttribute('data-adore-o')) t.setAttribute('data-adore-o',t.textContent); t.textContent='In your bag'; b.setAttribute(IN,String(id)); }
    function clearInBag(b){ var t=txtEl(b); if(t&&t.hasAttribute('data-adore-o')){ t.textContent=t.getAttribute('data-adore-o'); t.removeAttribute('data-adore-o'); } b.removeAttribute(IN); }
    function checkInBag(){ [].forEach.call(document.querySelectorAll('['+IN+']'),function(b){ var id=b.getAttribute(IN); if(btnId(b)!==id||!inCart(id)) clearInBag(b); }); }
    /* 25 Oct 2026 (panel audit, finding 2): until now a button only read "In your bag" after an add in the same page view. After
       Back from checkout, a reload, or a size change to a size already in the bag, it read "Add to cart" and one tap added a
       second rug. markInBag is the positive case of checkInBag: on a product page, every Add to cart button for the main
       product (page button and sticky bar clone) whose current variant is in the bag is marked "In your bag". It runs once
       the cart data is known (theme.Cart.currentData, which the theme fills from theme.loadedCartData on load; otherwise the
       first theme:cart::updated; otherwise one fetch of /cart.js after 3 s), and again after each size change or tap, right
       after checkInBag. It does nothing while the bag is empty or while an add is in flight. */
    function markInBag(){
      var d=C.currentData; if(!d||!d.items||!d.items.length) return;
      var h=document.querySelector('[data-js-product] h1'); if(!h) return;
      var scope=h.closest('[data-js-product]');
      var list=[].slice.call(scope.querySelectorAll('[data-js-product-button-add-to-cart]')).concat([].slice.call(document.querySelectorAll('.footbar-product [data-js-product-button-add-to-cart]')));
      list.forEach(function(b){
        if(b.disabled||b.classList.contains('active')||b.getAttribute('data-button-status')==='added') return;
        var t=txtEl(b); if(!t||t.hasAttribute('data-adore-t')) return;
        var id=btnId(b); if(!id||!inCart(id)) return;
        if(b.getAttribute(IN)!==id) setInBag(b,id);
      });
    }
    function syncInBag(){ checkInBag(); markInBag(); }
    /* 25 Oct 2026 (Nas, phone recording: the bag "disappears and reappears for a second" once the add completes): the bag was
       opened at the tap, then showPopup ran again after the refill. theme.Popups.callByName has no already-open check, it
       removes the bag's "show visible" classes and puts them back a tick later, so the open animation replayed over the new
       contents. openBag only calls showPopup when the bag is not open already. */
    function bagOpen(){ var c=document.querySelector('[data-js-popup-name="cart"]'); return !!(c&&c.classList.contains('visible')&&document.body.classList.contains('popup-opened')); }
    function openBag(){ if(!bagOpen()) C.showPopup(); }
    (function(){
      function boot(){ setTimeout(syncInBag,50); }
      if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
      setTimeout(function(){
        if(C.hasData||(C.currentData&&C.currentData.items)) return;
        fetch((C.rootURL||'/cart')+'.js',{credentials:'same-origin'}).then(function(r){ return r.json(); }).then(function(d){ if(d&&d.items){ C.setCurrentData(d); syncInBag(); } }).catch(function(){});
      },3000);
    })();
    document.addEventListener('change',function(){ setTimeout(syncInBag,120); },true);
    document.addEventListener('click',function(){ setTimeout(syncInBag,150); setTimeout(syncInBag,600); },true);
    document.addEventListener('theme:cart::updated',function(){ setTimeout(syncInBag,50); });
    function sizeText(){ var inp=idInput(), sel=inp&&inp.querySelector&&inp.querySelector('option:checked'); var v=sel?sel.textContent:'';
      v=(v||'').split('/')[0].split(' - ')[0].trim().replace(/(\d+)\s*x\s*(\d+)\s*cm/i,'$1 x $2 cm').replace(/(\d)cm\b/i,'$1 cm').replace(/\bRUNNER\b/,'runner'); return v; }
    function placeholder(on,$product){
      var old=document.querySelector('.adore-adding'); if(old) old.parentNode.removeChild(old);
      if(!on) return;
      var pop=document.querySelector(C.selectorPopup||'.js-popup-cart'); if(!pop) return;
      var h=$product&&$product[0]&&$product[0].querySelector('h1'), name=h?h.textContent.trim():'your rug', size=sizeText();
      var d=document.createElement('div'); d.className='adore-adding'; d.setAttribute('role','status');
      d.style.cssText='display:flex;align-items:center;gap:10px;margin:0 0 14px;padding:12px 14px;border-radius:10px;background:#F1EEE8;color:#1D1A17;font-size:14px;line-height:1.4;';
      d.innerHTML='<span aria-hidden="true" style="flex:0 0 16px;width:16px;height:16px;border:2px solid #4B5F4B;border-right-color:transparent;border-radius:50%;animation:adoreSpin .8s linear infinite"></span><span></span>';
      d.lastChild.textContent='Adding '+name+(size?', '+size:'')+' to your bag';
      if(!document.getElementById('adore-spin-kf')){ var st=document.createElement('style'); st.id='adore-spin-kf'; st.textContent='@keyframes adoreSpin{to{transform:rotate(360deg)}}'; document.head.appendChild(st); }
      pop.insertBefore(d,pop.firstChild);
    }
    /* c) start the bag request alongside the cart total: theme.Cart.addItem -> add.js -> updateData(cart.js); the bag HTML
       (getPopupContent, /cart?view=popup) used to start only after cart.js. Instance overrides only; theme.js untouched. */
    var origUD=C.updateData, origGPC=C.getPopupContent;
    if(typeof origUD==='function'&&typeof origGPC==='function'){
      C.updateData=function(r){ var p=origUD.apply(this,arguments); if(window.__adorePrePop===true){ window.__adorePrePop=origGPC.call(this); } return p; };
      C.getPopupContent=function(){ var pre=window.__adorePrePop; window.__adorePrePop=null; return (pre&&typeof pre.then==='function')?pre:origGPC.call(this); };
    }
    var sel=C.selectorButtonAdd||'.js-product-button-add-to-cart';
    var $b=$(document.body);
    $b.off('click',sel);
    $b.on('click',sel,function(e2){
      e2.preventDefault();
      var _=C, $this=$(this), st=$this.attr('data-button-status');
      if(st==='added'||$this.hasClass('active')) return;
      var $btns=_.mergeWithDuplicateButtons($this), $product=$this.parents('[data-js-product]'),
          isSlide=$product.parents('.slick-slide').length, $form=$product.find('form'),
          $formEls=$product.find('[form]'), formId=$form.attr('id');
      if(isSlide){ var nid='random-'+Math.floor(1000+Math.random()*9000)+'-'+formId; $form.attr('id',nid); $formEls.attr('form',nid); }
      if(st==='select'){ _.disableButton($btns); _.goToProductPage($product); return; }
      var $form2=$this.parents('form'), formData=_.serializeForm($form2);
      if(isSlide){ $form2.attr('id',formId); $formEls.attr('form',formId); }
      /* b) already in the bag in this size: open the bag instead of adding another */
      if(this.getAttribute(IN)&&this.getAttribute(IN)===String(formData.id)&&inCart(formData.id)){
        _.showPopup();
        /* 25 Oct 2026 (panel audit, finding 1): the sticky bar's button has no .js-product-button-add-to-cart class, so the
           theme's own second click handler ([data-js-product-button-add-to-cart]:not(...), theme.js addToCartController) still
           runs on it and calls disableButton on the pair 100 ms after every tap (class "active" plus disabled="disabled"),
           expecting the add flow to re-enable them later. This early return skipped that, so the first "In your bag" tap
           opened the bag and every later tap did nothing. Both buttons are re-enabled now, and again after the theme's
           100 ms timer has fired, so repeat taps keep opening the bag. */
        var reBtns=$btns, reSt=st;
        function reEnable(){ _.enableButton(reBtns,reSt); reBtns.removeClass('active').removeAttr('disabled'); }
        reEnable(); setTimeout(reEnable,150); setTimeout(reEnable,400);
        return;
      }
      if(this.getAttribute(IN)) clearInBag(this);
      _.disableButton($btns);
      /* 17 Oct 2026 (panel audit, UI/UX 3): the button says "Adding" straight away, so the 1 to 2 second wait reads as progress */
      function adding(on){ $btns.each(function(){ var t=txtEl(this); if(!t) return;
        if(on){ if(!t.hasAttribute('data-adore-t')) t.setAttribute('data-adore-t',t.textContent); t.textContent='Adding'; }
        else if(t.hasAttribute('data-adore-t')){ t.textContent=t.getAttribute('data-adore-t'); t.removeAttribute('data-adore-t'); } }); }
      adding(true);
      /* a) open the bag now with an "Adding ..." line (product pages only; quick-add from a grid keeps the old flow) */
      var onPage=!!($product[0]&&$product[0].querySelector('h1'));
      if(onPage){ try{ placeholder(true,$product); _.showPopup(); }catch(x){} }
      window.__adorePrePop=true;
      var done=false, timer=null;
      function finish(){ done=true; clearTimeout(timer); adding(false); }
      function free(){ finish(); window.__adorePrePop=null; placeholder(false); _.enableButton($btns,st); }
      function callback(){
        if(done) return; finish();
        document.dispatchEvent(new CustomEvent('theme:cart::added',{detail:{button:$this[0],product:$product[0],data:formData}}));
        Promise.resolve().then(function(){ return _.updateCart(); }).then(function(){
          placeholder(false); openBag(); _.statusButtonAdded($btns);
          setTimeout(function(){ _.enableButton($btns,st); $btns.each(function(){ setInBag(this,formData.id); }); },1500);
        }).catch(function(err){
          console.warn('[adore-atc] bag refresh failed',err);
          placeholder(false); window.__adorePrePop=null;
          try{ openBag(); }catch(x){}
          _.enableButton($btns,st);
        });
      }
      function recover(why){
        if(done) return;
        console.warn('[adore-atc]',why);
        fetch(_.rootURL+'.js',{credentials:'same-origin'}).then(function(r){ return r.json(); }).then(function(d){
          _.setCurrentData(d);
          var hit=d&&d.items&&d.items.some(function(it){ return String(it.variant_id)===String(formData.id); });
          if(hit){ callback(); } else { free(); }
        }).catch(free);
      }
      timer=setTimeout(function(){ recover('no answer after 10 s'); },10000);
      Promise.resolve().then(function(){ return _.addItem(formData); }).then(function(res){
        if(res&&res.ok){ callback(); }
        else if(res&&res.status===422){
          finish();
          return res.json().then(function(err){ alert(err.description); return _.updateData(); }).then(function(){ done=false; callback(); });
        }
        else { recover('add returned no usable response'); }
      }).catch(recover);
    });
    return true;
  }
  if(!install()){ var n=0, iv=setInterval(function(){ if(install()||++n>150) clearInterval(iv); },100); }
})();

(function(){
  function go(){
    var T=window.theme; if(!T||!T.AssetsLoader||!T.ProductOptions||typeof T.ProductOptions._updatePrice!=='function') return false;
    if(document.querySelector('[data-js-product]')){ try{ T.AssetsLoader.require('scripts','theme_pt2'); }catch(e){} }
    var PO=T.ProductOptions;
    if(!PO.__adorePP){
      PO.__adorePP=true;
      var orig=PO._updatePrice;
      PO._updatePrice=function(){
        var self=this, args=arguments;
        if(T.ProductPrice&&typeof T.ProductPrice.insertFull==='function') return orig.apply(self,args);
        try{ T.AssetsLoader.require('scripts','theme_pt2'); }catch(e){}
        var n=0, iv=setInterval(function(){
          if(T.ProductPrice&&typeof T.ProductPrice.insertFull==='function'){ clearInterval(iv); try{ orig.apply(self,args); }catch(e){} }
          else if(++n>80){ clearInterval(iv); }
        },100);
      };
    }
    return true;
  }
  if(!go()){ var n=0, iv=setInterval(function(){ if(go()||++n>100) clearInterval(iv); },100); }
})();

(function(){
  function go(){
    var T=window.theme, G=T&&T.Global; if(!G||typeof G.fixBody!=='function'||G.__adoreLight) return !!(G&&G.__adoreLight);
    G.__adoreLight=true;
    var origFix=G.fixBody, origUnfix=G.unfixBody, light=false, y=0;
    function phone(){ return window.matchMedia('(max-width: 1024px)').matches; }
    G.fixBody=function(){
      if(!phone()) return origFix.apply(this,arguments);
      light=true; y=window.pageYOffset||0;
      document.documentElement.classList.add('adore-lock');
      document.body.classList.add('adore-lock-body');
    };
    /* 24 Oct 2026 (panel audit, build 9): the theme focuses the bag when it opens, and with this lighter lock the browser
       answered that focus by scrolling the page behind the bag to the footer (6,375 px on Marmaris). While the lock is on,
       any window scroll is put straight back to where the shopper was, so lazy images do not load, the sticky bar does not
       fire, and the Back memory keeps the right spot. */
    window.addEventListener('scroll',function(){ if(light && Math.abs((window.pageYOffset||0)-y)>1) window.scrollTo(0,y); },{passive:true});
    /* 24 Oct 2026 (panel audit, build 9, second pass): the jump comes from the theme calling focus() on the popup element when it
       opens. On phones that focus now asks the browser not to scroll (preventScroll), which stops the jump before it happens;
       the scroll listener above stays as the backstop. Desktop keeps the theme's own behaviour. */
    function quietFocus(){
      var pf=HTMLElement.prototype.focus;
      [].forEach.call(document.querySelectorAll('.popup'),function(p){
        if(p.__adoreQuiet) return; p.__adoreQuiet=true;
        p.focus=function(o){ var opt=o||{}; if(phone()) opt.preventScroll=true; return pf.call(this,opt); };
      });
    }
    quietFocus();
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',quietFocus); else setTimeout(quietFocus,0);
    G.unfixBody=function(){
      if(!light) return origUnfix.apply(this,arguments);
      light=false;
      document.documentElement.classList.remove('adore-lock');
      document.body.classList.remove('adore-lock-body');
      if(Math.abs((window.pageYOffset||0)-y)>2) window.scrollTo(0,y);
    };
    return true;
  }
  if(!go()){ var n=0, iv=setInterval(function(){ if(go()||++n>100) clearInterval(iv); },100); }
})();

/* 24 Oct 2026 (Nas, build 9 audit): tapping plus or minus in the bag changed the number at once, but the totals and the
   checkout amount only caught up 2 to 3 seconds later (the theme waits 0.7 s, then the cart call takes about 1 s, then the
   bag HTML is fetched), with nothing to show work was happening. Now the footer totals dim and a small "Updating" note
   shows the moment a quantity button or the quantity field changes, until the bag redraws. */
(function(){
  var CLS='adore-updating', tm=0;
  function footer(){ return document.querySelector('.popup-cart .popup-cart__footer'); }
  function start(){
    var f=footer(); if(!f || f.classList.contains(CLS)) return;
    f.classList.add(CLS);
    /* 24 Oct 2026 (panel audit): if the cart call fails the bag never redraws, so clear the dimmed state after 10 seconds */
    clearTimeout(tm); tm=setTimeout(stop,10000);
    var sub=f.querySelector('.popup-cart__subtotal');
    if(sub && !sub.querySelector('.adore-updating__note')){
      var n=document.createElement('span'); n.className='adore-updating__note'; n.textContent='Updating'; sub.appendChild(n);
    }
  }
  function stop(){ var f=footer(); if(f){ f.classList.remove(CLS); var n=f.querySelector('.adore-updating__note'); if(n) n.remove(); } }
  document.addEventListener('click',function(e){
    var t=e.target; if(!t||!t.closest) return;
    if(t.closest('.popup-cart .input-quantity [data-control]')) start();
  },true);
  document.addEventListener('change',function(e){
    var t=e.target; if(t && t.matches && t.matches('.popup-cart input.js-input-quantity-cart')) start();
  },true);
  document.addEventListener('theme:cart::updated',function(){ setTimeout(stop,0); });
  var st=document.createElement('style');
  st.textContent='.popup-cart__footer.adore-updating .popup-cart__subtotal > p,.popup-cart__footer.adore-updating .adore-cart-save,.popup-cart__footer.adore-updating .adore-bag-row,.popup-cart__footer.adore-updating input[name="checkout"],.popup-cart__footer.adore-updating .adore-fx-cart-trust{opacity:.45;transition:opacity .15s}'+
    '.adore-updating__note{display:inline-block;margin-left:10px;font-size:13px;font-weight:400;color:#57504A;vertical-align:middle}';
  document.head.appendChild(st);
})();

/* 24 Oct 2026 (panel audit, build 9): the sticky bar printed "Add To Cart" in title case while every other button is sentence case. */
(function(){
  function fix(){ [].forEach.call(document.querySelectorAll('.footbar-product .btn > span:not([data-button-content])'),function(s){ if(!s.children.length && /^\s*Add To Cart\s*$/.test(s.textContent)) s.textContent='Add to cart'; }); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fix); else fix();
})();

/* 26 Oct 2026 (panel audit on the live site, finding 2): after Back from checkout the page came back from the browser's cache with
   the bag, header count and "In your bag" labels from when it was first loaded, not the real cart (the panel saw "My bag (3),
   $1,345" while /cart.js held 2 items, $955, and a Secure checkout button for a bag that did not exist). The theme reads its baked
   in cart data once, in the CartData constructor, and never again. Now, when a page is shown by Back or Forward (bfcache restore,
   or a back_forward navigation), the real cart is fetched from /cart.js, handed to theme.Cart, and if the count or total differs
   the bag, the cart page and the header count are redrawn. theme:cart::updated then runs the "In your bag" check above. */
(function(){
  var busy=false;
  function refresh(){
    var C=window.theme&&window.theme.Cart;
    if(busy||!C||typeof C.setCurrentData!=='function') return;
    busy=true;
    fetch((C.rootURL||'/cart')+'.js',{credentials:'same-origin',cache:'no-store'}).then(function(r){ return r.json(); }).then(function(d){
      if(!d||!d.items) return;
      var cur=C.currentData||{};
      var same=(cur.item_count===d.item_count && cur.total_price===d.total_price);
      C.setCurrentData(d);
      if(window.theme.loadedCartData) window.theme.loadedCartData=d;
      if(same) return;
      return Promise.resolve().then(function(){ return typeof C.updateCart==='function' ? C.updateCart() : null; }).catch(function(){})
        .then(function(){ document.dispatchEvent(new CustomEvent('theme:cart::updated')); });
    }).catch(function(){}).then(function(){ busy=false; });
  }
  window.addEventListener('pageshow',function(e){
    var nav=(performance.getEntriesByType&&performance.getEntriesByType('navigation')[0])||null;
    if(e.persisted || (nav&&nav.type==='back_forward')){ setTimeout(refresh,50); setTimeout(refresh,1500); }
  });
})();
